<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Dashboard">
        <template #header>
            Dashboard
        </template>

        <!-- <div class="sm:p-6 grid sm:grid-cols-2 sm:gap-8">
            <banners />
            <videos />
        </div> -->

        <div class="m-1.5 sm:m-4 h-full bg-opacity-0">
            <div class="h-full">
                <play :user="$page.props.user"/>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/Layout'
import Play from '@/Global/Play/Play'
import Scores from '@/Global/Scores/Scores'
import Leagues from '@/Global/Leagues/Leagues'
import Banners from '@/Global/Banners/Banners'
import Videos from '@/Global/Videos/Videos'
import Popper from 'vue3-popper'
import moment from "moment/moment";
import {onMounted} from "vue";
import axios from "axios";

export default {
    props: {
        meetings: {
            type: Object,
            default: {},
        },
    },

    components: {
        AppLayout,
        Play,
        Scores,
        Leagues,
        Banners,
        Videos,
        Popper
    },
}
</script>
